import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveExtensionMutation = gql`
   mutation SaveExtension(
      $extension: ExtensionInput!
      $deletedAutoAttendantKeyIds: [UInt!]!
      $deletedAutoAttendantPromptIds: [UInt!]!
      $deletedPagingGroupMemberIds: [UInt!]!
      $deletedHuntGroupMemberIds: [UInt!]!
      $deletedQueueMemberIds: [UInt!]!
      $deletedTimeBasedRouteIds: [UInt!]!
      $deletedExtensionSuperviseeIds: [UInt!]!
      $deletedExtensionGroupSuperviseeIds: [UInt!]!
      $deletedPagingGroupExtensionGroupIds: [UInt!]!
      $deletedExtensionHuntGroupIds: [UInt!]!
      $deletedExtensionQueueGroupIds: [UInt!]!
      $deletedPhoneIds: [UInt!]!
      $deletedQueuePeriodicAnnouncementIds: [UInt!]!
      $deletedFaxEmailAddressIds: [UInt!]!
      $deletedDepartmentExtensionIds: [UInt!]!
      $deletedFmFmSteps: [UInt!]!
      $deletedFmFmStepExtensions: [UInt!]!
      $deletedFmFmStepPhoneNumbers: [UInt!]!
      $deletedBaseStationHandsetIds: [UInt!]!
      $deletedNoteIds: [UInt!]!
      $hasDeletedKeys: Boolean = false
      $hasDeletedPrompts: Boolean = false
      $hasDeletedPagingGroupMembers: Boolean = false
      $hasDeletedHuntGroupMembers: Boolean = false
      $hasDeletedQueueMembers: Boolean = false
      $hasDeletedPhones: Boolean = false
      $hasDeletedTimeBasedRoutes: Boolean = false
      $hasDeletedExtensionSupervisees: Boolean = false
      $hasDeletedExtensionHuntGroups: Boolean = false
      $hasDeletedPagingGroupExtensionGroups: Boolean = false
      $hasDeletedExtensionQueueGroups: Boolean = false
      $hasDeletedExtensionGroupSupervisees: Boolean = false
      $hasDeletedPeriodicAnnouncements: Boolean = false
      $hasDeletedFaxEmailAddresses: Boolean = false
      $hasDeletedDepartmentExtensions: Boolean = false
      $hasDeletedFmFmSteps: Boolean = false
      $hasDeletedFmFmStepExtensions: Boolean = false
      $hasDeletedFmFmStepPhoneNumbers: Boolean = false
      $hasDeletedBaseStationHandsets: Boolean = false
      $hasDeletedNotes: Boolean = false
   ) {
      deleteAutoAttendantKeys(ids: $deletedAutoAttendantKeyIds) @include(if: $hasDeletedKeys)
      deleteAutoAttendantPrompts(ids: $deletedAutoAttendantPromptIds) @include(if: $hasDeletedPrompts)
      deleteHuntGroupMembers(ids: $deletedHuntGroupMemberIds) @include(if: $hasDeletedHuntGroupMembers)
      deleteQueueMembers(ids: $deletedQueueMemberIds) @include(if: $hasDeletedQueueMembers)
      deleteTimeBasedRoutes(ids: $deletedTimeBasedRouteIds) @include(if: $hasDeletedTimeBasedRoutes)
      deleteExtensionSupervisees(ids: $deletedExtensionSuperviseeIds) @include(if: $hasDeletedExtensionSupervisees)
      deleteExtensionGroupSupervisees(ids: $deletedExtensionGroupSuperviseeIds)
         @include(if: $hasDeletedExtensionGroupSupervisees)
      deleteHuntGroupExtensionGroups(ids: $deletedExtensionHuntGroupIds) @include(if: $hasDeletedExtensionHuntGroups)
      deleteQueueExtensionGroups(ids: $deletedExtensionQueueGroupIds) @include(if: $hasDeletedExtensionQueueGroups)
      deletePhones(ids: $deletedPhoneIds) @include(if: $hasDeletedPhones)
      deleteQueuePeriodicAnnouncements(ids: $deletedQueuePeriodicAnnouncementIds)
         @include(if: $hasDeletedPeriodicAnnouncements)
      deleteFaxEmailAddresses(ids: $deletedFaxEmailAddressIds) @include(if: $hasDeletedFaxEmailAddresses)
      deleteDepartmentExtensions(ids: $deletedDepartmentExtensionIds) @include(if: $hasDeletedDepartmentExtensions)
      deleteFmFmSteps(ids: $deletedFmFmSteps) @include(if: $hasDeletedFmFmSteps)
      deleteFmFmStepExtensions(ids: $deletedFmFmStepExtensions) @include(if: $hasDeletedFmFmStepExtensions)
      deleteFmFmStepPhoneNumbers(ids: $deletedFmFmStepPhoneNumbers) @include(if: $hasDeletedFmFmStepPhoneNumbers)
      deleteBaseStationHandsets(ids: $deletedBaseStationHandsetIds) @include(if: $hasDeletedBaseStationHandsets)

      deletePagingGroupExtensionGroups(ids: $deletedPagingGroupExtensionGroupIds)
         @include(if: $hasDeletedPagingGroupExtensionGroups)

      deletePagingGroupMembers(ids: $deletedPagingGroupMemberIds) @include(if: $hasDeletedPagingGroupMembers)
      deleteNotes(ids: $deletedNoteIds) @include(if: $hasDeletedNotes)

      extension: saveExtension(extension: $extension) {
         extensionId
         name
         shortName
         number
         type
         accountId
         mailboxId
         usersConnection {
            items {
               userId
               extensionId
            }
         }
         locationId
         adminNote {
            noteId
            accountId
            notes
            isSystemNote
            extensionId
         }
         extensionNote {
            noteId
            accountId
            notes
            isSystemNote
         }
         timeZoneId
         faxEmailAddressesConnection {
            items {
               faxEmailAddressId
               emailAddress
               isDomainOnly
               extensionId
            }
         }
         departmentExtensionsConnection {
            items {
               departmentExtensionId
               departmentId
               department {
                  departmentId
                  name
                  isActive
                  accountId
               }
               extensionId
            }
         }
         extensionPhone {
            extensionPhoneId
            extensionId
            displayName
            ringTimeout
            enableDtmf
            secondsToWait
            dtmfToPlay
            isOtrEnabled
            defaultPhoneNumberId
            dndStatus
            forwardExtensionId
            forwardExternalNumber
            routeBusyExtensionId
            routeBusyNullAction
            routeNoAnswerExtensionId
            routeNoAnswerNullAction
            isAutoAnswer
            isRingAllPhones
            autoAnswerPhoneId
            isAutoAnswerEnabled
            defaultAreaCode
            office
            phonesConnection {
               items {
                  extensionId
                  phoneId
                  phoneType
                  handsetIpei
                  sipUsersConnection {
                     items {
                        sipUserId
                        userName
                        hashPassword
                        phoneId
                        accountId
                     }
                  }
                  devicesConnection {
                     items {
                        deviceId
                        phoneId
                     }
                  }
                  baseStationHandsetsConnection {
                     items {
                        baseStationHandsetId
                        phoneId
                        deviceId
                        sortId
                     }
                  }
               }
            }
            extensionSuperviseesConnection {
               items {
                  extensionSuperviseeId
                  supervisorExtensionId
                  superviseeExtensionId
               }
            }
            extensionGroupSuperviseesConnection {
               items {
                  extensionGroupSuperviseeId
                  supervisorExtensionId
                  superviseeExtensionGroupId
               }
            }
         }
         extensionAutoAttendant {
            extensionAutoAttendantId
            extensionId
            timeoutSeconds
            timeoutExtensionId
            firstPromptNotSkippable
            timeoutNullAction
            isTimeoutVoicemailOnly
            autoAttendantKeysConnection {
               items {
                  autoAttendantKeyId
                  extensionAutoAttendantId
                  keyNumber
                  routeTo
                  voiceMailOnly
                  routeToNullAction
               }
            }
            autoAttendantPromptsConnection {
               items {
                  autoAttendantPromptId
                  extensionAutoAttendantId
                  sortId
                  promptId
               }
            }
         }
         extensionExternalForward {
            extensionExternalForwardId
            extensionId
            forwardToNumber
            isPassthroughOriginalCallerId
            dtmf
            pauseSeconds
            isDtmf
         }
         extensionPagingGroup {
            extensionId
            extensionPagingGroupId
            pagingGroupMembersConnection {
               items {
                  pagingGroupMemberId
                  extensionPagingGroupId
                  extensionId
               }
            }
            pagingGroupExtensionGroupsConnection {
               items {
                  pagingGroupExtensionGroupId
                  extensionPagingGroupId
                  extensionGroupId
               }
            }
         }
         extensionHuntGroup {
            extensionHuntGroupId
            extensionId
            displayName
            ringTimeout
            callerIdOverride
            routeBusyExtensionId
            routeNoAnswerExtensionId
            isRouteBusyVoicemailOnly
            isRouteNoAnswerVoicemailOnly
            routeBusyNullAction
            routeNoAnswerNullAction
            huntGroupMembersConnection {
               items {
                  huntGroupMemberId
                  extensionHuntGroupId
                  extensionId
               }
            }
            extensionGroupHuntGroupMembersConnection {
               items {
                  huntGroupExtensionGroupId
                  huntGroupExtensionId
                  extensionGroupId
               }
            }
         }
         timeBasedRoutesConnection {
            items {
               timeBasedRouteId
               extensionId
               startDate
               endDate
               startTime
               endTime
               priorityId
               comment
               isActiveMonday
               isActiveTuesday
               isActiveWednesday
               isActiveThursday
               isActiveFriday
               isActiveSaturday
               isActiveSunday
               routeExtensionId
               routeExtensionNullAction
            }
         }
         extensionMailbox {
            extensionMailboxId
            extensionId
            notes
            customerNotes
         }
         extensionQueue {
            extensionQueueId
            extensionId
            queueStrategyId
            wrapUpTime
            announcementFrequency
            holdMusicPromptId
            isAnnounceWaitTime
            isCallBackAvailable
            callersNeededForCallback
            callBackType
            holdTimeNeededForCallback
            customCallbackPromptId
            isAnnounceQueueCount
            isAnnounceCallback
            exitRouteTo
            exitRouteVoicemailOnly
            periodicAnnouncementFrequency
            hasPreventEmptyQueue
            queueEmptyExitRouteTo
            queueEmptyExitNullAction
            queueMembersConnection {
               items {
                  queueMemberId
                  extensionQueueId
                  extensionQueue {
                     extensionQueueId
                     extensionId
                     extension {
                        extensionId
                        name
                        number
                     }
                  }
                  agentExtensionId
               }
            }
            queueExtensionGroupMembersConnection {
               items {
                  queueExtensionGroupId
                  queueExtensionId
                  extensionGroupId
                  extensionGroup {
                     name
                     description
                  }
               }
            }
            queuePeriodicAnnouncementsConnection {
               items {
                  queuePeriodicAnnouncementId
                  extensionQueueId
                  promptId
                  sortOrder
               }
            }
         }
         extensionFax {
            extensionFaxId
            extensionId
            defaultPhoneNumberId
            emailAddress
            faxEmailAddressesConnection {
               items {
                  faxEmailAddressId
                  emailAddress
                  isDomainOnly
                  extensionId
               }
            }
         }
         extensionFmFm {
            extensionFmFmId
            extensionId
            finalDestinationExtensionId
            isFinalDestinationVoicemail
            isIgnoreForward
            isGreetingDisabled
            isSendOriginalCallerId
            finalDestinationPhoneNumber
            defaultPhoneNumberId
            fmFmStepsConnection {
               items {
                  fmFmStepId
                  extensionFmFmId
                  timeout
                  sequence
                  fmFmStepPhoneNumbersConnection {
                     items {
                        fmFmStepPhoneNumberId
                        fmFmStepId
                        phoneNumber
                     }
                  }
                  fmFmStepExtensionsConnection {
                     items {
                        fmFmStepExtensionId
                        extensionId
                        fmFmStepId
                     }
                  }
               }
            }
         }
         mailbox {
            emailAddress
            markReadAfterEmail
            discardAudioAfterEmail
            sayCallerId
            isInNameDirectory
            unavailablePromptId2
            temporaryUnavailablePromptId
            mailboxId
            namePromptId
            operatorExtensionId
            password
            busyPromptId
         }
      }
   }
`;
